<page-load-header *ngIf="!initialized"></page-load-header>

<h3>Upload a video file</h3>
<div *ngIf="initialized" class="container-fluid">
  <!-- <kendo-upload [saveUrl]="uploadUrl" [multiple]="false" (success)="successEventHandler($event)"></kendo-upload>

  <input (change)="onFileChange($event)" type="file" id="fileUpload" /> -->

  <div class="row bg-white">
    <div class="col border p-4">
      <label class="btn btn-sm btn-primary transition-3d-hover file-attachment-btn" for="fileAttachmentBtn">
        Choose file to upload
        <input [promiseBtn]="uploading" (change)="onFileChange($event)" id="fileAttachmentBtn" name="file-attachment" type="file" class="file-attachment-btn__label" />
      </label>
      {{currentFile?.name}}

      <div *ngIf="percentComplete >= 0" class="progress mt-4" style="height: 20px;">
        <div class="progress-bar bg-alternate" role="progressbar" [ngStyle]="{'width': percentComplete + '%'}"  aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">{{percentComplete}}%</div>
      </div>
    </div>
  </div>

  <!-- <button type="button" (click)="upload()">Upload</button> -->
</div>
